/*
 * @Author: chen zhen
 * @Date: 2018-10-23 15:00:01
 * @Last Modified by: Nie Wei
 * @Last Modified time: 2020-01-13 11:29:41
 * @Description: 进行重置大小的事件插拔
 */
import { APPEND_RESIZE_EVENT, REMOVE_RESIZE_EVENT } from '@/store/common'

const mixin = {
  mounted() {
    if (_.isFunction(this.resize)) {
      this.resize()
      this.$store.commit(`common/${APPEND_RESIZE_EVENT}`, this.resize.bind(this))
    }
  },
  methods: {
    /**
     * @description: 格式化数字，千分位加逗号
     * @param {Number} num 要格式化的数据
     * @return: 格式化后的数字（String）
     */
    toThousands(num) {
      const number = parseFloat(num)
      const numArr = (number || 0).toString().split('.')
      const intNum = numArr[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      return numArr[1] ? `${intNum}.${numArr[1]}` : intNum
    },
  },
  beforeDestroy() {
    if (_.isFunction(this.resize)) this.$store.commit(`common/${REMOVE_RESIZE_EVENT}`, this.resize.bind(this))
  },
}

export default mixin
